import React from "react";
import {
  Container,
  Box,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Chip,
} from "@mui/material";

const BattleDisplay = ({ battle }) => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          {battle?.title || "Battle Arena"}
        </Typography>
        <Paper sx={{ p: 3 }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <Chip
                  label={`Type: ${battle?.type || "Unknown"}`}
                  color="primary"
                />
                <Chip
                  label={`Status: ${battle?.status || "In Progress"}`}
                  color="secondary"
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {battle?.characters?.map((character, index) => (
                  <Grid item xs={12} sm={6} md={3} key={index}>
                    <Card>
                      <CardMedia
                        component="img"
                        height="140"
                        image={`https://via.placeholder.com/140x140.png?text=${character}`}
                        alt={character}
                      />
                      <CardContent>
                        <Typography variant="h6" component="div">
                          {character}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h5" gutterBottom>
                Battle Story
              </Typography>
              <Typography variant="body1" paragraph>
                {battle?.story || "The battle is about to begin..."}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Container>
  );
};

export default BattleDisplay;
